var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('employment-doc-body', _vm._b({
    attrs: {
      "withoutReset": ""
    },
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "head-left",
      fn: function () {
        return [_c('div', {
          staticStyle: {
            "max-width": "240px",
            "margin": "-5px -12px"
          }
        }, [_c('body-name', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.name,
            callback: function ($$v) {
              _vm.$set(_vm.form, "name", $$v);
            },
            expression: "form.name"
          }
        }, [_c('body-file', {
          attrs: {
            "mode": "button"
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.file,
            callback: function ($$v) {
              _vm.$set(_vm.form, "file", $$v);
            },
            expression: "form.file"
          }
        })], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.fields,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fields", $$v);
      },
      expression: "form.fields"
    }
  }, 'employment-doc-body', {
    mode: _vm.mode,
    pages: _vm.pages
  }, false), [_c('body-file', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.file,
      callback: function ($$v) {
        _vm.$set(_vm.form, "file", $$v);
      },
      expression: "form.file"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }